const THEME_STORAGE_KEY = 'kdp-theme'
const THEMES = ['light', 'dark', 'system']

export function getStoredTheme() {
    try {
        const storedTheme = localStorage.getItem(THEME_STORAGE_KEY)
        return THEMES.includes(storedTheme) ? storedTheme : 'system'
    } catch (error) {
        return 'system'
    }
}

export function getResolvedTheme(theme = getStoredTheme()) {
    if (theme !== 'system') return theme

    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function applyTheme(theme = getStoredTheme()) {
    const resolvedTheme = getResolvedTheme(theme)
    const root = document.documentElement

    root.dataset.theme = resolvedTheme
    root.style.colorScheme = resolvedTheme

    const themeColor = resolvedTheme === 'dark' ? '#171522' : '#ffffff'
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', themeColor)

    return resolvedTheme
}

export function setTheme(theme) {
    const nextTheme = THEMES.includes(theme) ? theme : 'system'

    try {
        localStorage.setItem(THEME_STORAGE_KEY, nextTheme)
    } catch (error) {
        // The visual theme still applies when storage is unavailable.
    }

    applyTheme(nextTheme)
    window.dispatchEvent(new CustomEvent('kdp-theme-change', { detail: nextTheme }))

    return nextTheme
}

export function toggleTheme() {
    return setTheme(getResolvedTheme() === 'dark' ? 'light' : 'dark')
}

export { THEMES, THEME_STORAGE_KEY }
